import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { resolveImg } from "@/lib/api";

export const Gallery = ({ images = [], title }) => {
  const [idx, setIdx] = useState(null);
  if (!images.length) return null;
  const go = (d) => setIdx((i) => (i + d + images.length) % images.length);
  return (
    <>
      <div data-testid="gallery-grid" className="grid grid-cols-3 md:grid-cols-4 gap-2">
        {images.map((src, i) => (
          <button key={src} type="button" data-testid={`gallery-thumb-${i}`} onClick={() => setIdx(i)} className={`relative overflow-hidden rounded-lg aspect-[4/3] group ${i === 0 ? "col-span-2 row-span-2" : ""}`}>
            <img src={resolveImg(src)} alt={`${title} photo ${i + 1}`} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
          </button>
        ))}
      </div>
      <Dialog open={idx !== null} onOpenChange={(o) => !o && setIdx(null)}>
        <DialogContent className="max-w-4xl p-0 bg-indigo-deep border-none overflow-hidden">
          {idx !== null && (
            <div className="relative">
              <img src={resolveImg(images[idx])} alt="" className="w-full max-h-[80vh] object-contain" />
              {images.length > 1 && (
                <>
                  <button type="button" data-testid="gallery-prev" onClick={() => go(-1)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-2"><ChevronLeft className="w-5 h-5" /></button>
                  <button type="button" data-testid="gallery-next" onClick={() => go(1)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-2"><ChevronRight className="w-5 h-5" /></button>
                </>
              )}
              <div className="absolute bottom-2 inset-x-0 text-center text-xs text-white/80">{idx + 1} / {images.length}</div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
